// SimpleColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Flex, Grid, Tooltip } from 'antd';
import utils from 'utils/utils';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const { useBreakpoint } = Grid;

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
export const SimpleColumn = ({ items = [], className }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes('sm');

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Flex wrap="wrap" gap="large">
      <Flex
        vertical
        style={{
          flex: 1,
          minWidth: 0, // Allows flex item to shrink below content size
          maxWidth: '100%',
          paddingRight: isMobile ? 0 : 24,
          paddingBottom: isMobile ? '0.5rem' : 0,
          overflow: 'hidden',
        }}
        gap={isMobile ? '0.5rem' : '0'}
      >
        {items.map((item, idx) => {
          // Inner row: icon + label. When item has a tooltip, wrap both in inline-flex so
          // the tooltip anchors to the natural content width (not the full container width).
          // max-width: 100% ensures the span never exceeds the container, so long text
          // is still clipped by overflow: hidden + text-overflow: ellipsis on the label.
          const row = (
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                maxWidth: '100%',
                overflow: 'hidden',
                minWidth: 0,
              }}
            >
              <span className="text-primary font-size-md" style={{ flexShrink: 0 }}>
                {item.icon}
              </span>
              <span
                className="text-muted"
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  minWidth: 0,
                }}
              >
                {item.label}
              </span>
            </span>
          );

          return (
            <div
              key={item?.key || idx}
              style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                cursor: item.onClick ? 'pointer' : 'default',
                overflow: 'hidden',
                minWidth: 0,
              }}
              onClick={item.onClick}
            >
              {item.tooltipText ? (
                <Tooltip
                  title={item.tooltipText}
                  placement={item.tooltipPlacement || 'top'}
                  styles={{
                    root: { maxWidth: 200 },
                    body: { wordWrap: 'break-word' },
                  }}
                >
                  {row}
                </Tooltip>
              ) : (
                row
              )}
            </div>
          );
        })}
      </Flex>
    </Flex>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SimpleColumn;
